import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    accessToken: null,
    reloadTrigger: false,
    show: false,
    clients: [],
    currentClientUID: null,
    productTree: [],
    internationalToothConvention: "fdi",
    incompleteSubmissions: [],
  },
  getters: {
    accessToken: (state) => state.accessToken,
    isLoggedIn: (state) => !!state.accessToken,
    clients: (state) => state.clients,
    currentClient: (state) => {
      return state.clients.find(
        (client) => client.uid === state.currentClientUID
      );
    },
    targetCountry: (_, getters) => {
      if (getters.currentClient) {
        return getters.currentClient.country_code;
      }
    },
    internationalToothConvention: (state) => state.internationalToothConvention,
    incompleteSubmissions: (state) => state.incompleteSubmissions,
  },
  mutations: {
    SET_ACCESS_TOKEN(state, payload) {
      state.accessToken = payload;
    },
    SET_CLIENTS(state, clients) {
      if (clients.length === 1) {
        state.currentClientUID = clients[0].uid;
      }
      state.clients = clients;
    },
    SET_CURRENT_CLIENT(state, client) {
      if (!client) {
        return (state.currentClientUID = null);
      }
      state.currentClientUID = client.uid;
    },
    SET_INTERNATIONAL_TOOTH_CONVENTION(state, convention) {
      state.internationalToothConvention = convention;
    },
    SET_INCOMPLETE_SUBMISSIONS(state, incompleteSubmissions) {
      state.incompleteSubmissions = incompleteSubmissions;
    },
  },
  actions: {
    setAccessToken({ commit }, token) {
      commit("SET_ACCESS_TOKEN", token);
    },
    setClients({ commit }, clients) {
      commit("SET_CLIENTS", clients);
    },
    setCurrentClient({ commit }, client) {
      commit("SET_CURRENT_CLIENT", client);
    },
    setInternationalToothConvention({ commit }, convention) {
      commit("SET_INTERNATIONAL_TOOTH_CONVENTION", convention);
    },
    setIncompleteSubmissions({ commit }, incompleteSubmissions) {
      commit("SET_INCOMPLETE_SUBMISSIONS", incompleteSubmissions);
    },
  },
  modules: {},
});
